import Logger, { DebugLevels, setDebugLevel, setLogClient,
  CompositeLogClient, ConsoleLogClient } from '@cvent/nucleus-logging';
import RemoteLogClient from 'nucleus-core/utils/RemoteLogClient';
import { SessionTimedOutError } from '../dialogs/SessionTimedOutDialog';
import { ServiceError } from 'event-widgets/utils/errors';
import redirectToErrorPage from '../utils/redirectToErrorPage';
import { httpLogPageLoadId } from '@cvent/nucleus-networking';

const LOG = new Logger('event-guestside-site/GLOBAL');

let remoteClient;

// For tests
export function setRemoteLogClient(value) {
  remoteClient = value;
}

export async function logErrorAndRedirect(message, exception, appSettings) {
  try {
    if (exception instanceof SessionTimedOutError) {
      return;
    }

    const errorType = (exception instanceof ServiceError)
      ? 'ServiceError'
      : 'ClientError';

    LOG.error(message, errorType, exception);
    if (remoteClient) {
      const flushPromise = remoteClient.flushNow();
      const timeoutPromise = new Promise(resolve => setTimeout(resolve, 2500));
      await Promise.race([flushPromise, timeoutPromise]);
    }

    if (appSettings.isDebug) {
      // eslint-disable-next-line no-alert
      alert(
        'A fatal error occurred. This will cause the instance page to appear in production. '
        + 'Look at console for more details on what occurred. To enable fatal error page '
        + 'run the command "IS_DEBUG=false yarn dev"');
    } else {
      redirectToErrorPage(appSettings.viewRoot, appSettings.eventContext.eventId,
        appSettings.environment, exception.httpLogRequestId);
    }
  } catch (e) {
    console.error('Error logging.', e); // eslint-disable-line no-console
  }
}

export function initializeLogging(appSettings) {
  const {
    debugLevel = DebugLevels.WARN,
    logToServer = true,
    environment,
    serviceBaseUrl
  } = appSettings;

  setDebugLevel(debugLevel);
  if (logToServer) {
    remoteClient = new RemoteLogClient({
      context: { httpLogPageLoadId },
      url: `${serviceBaseUrl}/v1/log?environment=${environment}`,
      maxMessagesPerInterval: 200,
      maxWaitMs: 5000
    });
    const compositeClient = new CompositeLogClient(remoteClient, new ConsoleLogClient());
    setLogClient(compositeClient);
  }
  global.onunhandledrejection = async (event) => {
    let reason;
    try {
      reason = await event.reason;
      if (!reason) {
        reason = { message: 'unhandledrejection event had no reason', event };
      }
    } catch (error) {
      reason = error;
      if (!reason) {
        reason = { message: 'unhandledrejection event reason promise rejected with no value', event };
      }
    }
    logErrorAndRedirect('Global Unhandled Promise Rejection', reason, appSettings);
  };
  window.onerror = (message, file, line, column, error) => {
    logErrorAndRedirect('Global Unhandled Error', error, appSettings);
  };
}
